import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  HStack,
  Input,
  Text,
  VStack,
  Checkbox,
} from "@chakra-ui/react";
import React from "react";
import { useAuth } from "../../providers/AuthProvider";
import axios from "axios";
import { url } from "../../config";
import { toast } from "react-toastify";
import { useStoreLocations } from "../../providers/LocationProvider";
import { Link } from "react-router-dom";
import moment from "moment";
import { MEMBERSHIP_STATUSES } from "../utils/membership_statuses";

export default function AdminReport() {
  const { token } = useAuth();
  var { location } = useStoreLocations();

  const [filteredData, setFilteredData] = React.useState([]);
  const [isSetToShowAll, setIsSetToShowAll] = React.useState(true);

  const [date, setDate] = React.useState("");
  const [year, setYear] = React.useState("");
  const [selectedLocation, setSelectedLocation] = React.useState("-1");
  const [status, setStatus] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [enrolled, setEnrolled] = React.useState([]);
  const [collection, setCollection] = React.useState([]);
  const [pendingCollection, setPendingCollection] = React.useState([]);
  const [pending, setPending] = React.useState([]);
  // const [newUsers, setNewUsers] = React.useState([]);

  function getReportData() {
    if (date === "") {
      alert("Please select a month");
      return;
    }

    if (year === "") {
      alert("Please select a year");
      return;
    }

    setLoading(true);
    // fetch report data
    axios
      .post(
        `${url}/report`,
        { month: date, year: year, location: selectedLocation, status: status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        setEnrolled(response.data.enrolled);
        setCollection(response.data.collection);
        setPendingCollection(response.data.pendingCollection);
        setPending(response.data.pendingPayment);

        setFilteredData(response.data.pendingPayment);

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching report data:", error);
        // alert('Failed to fetch report data');
        toast.error("Failed to fetch report data");
      });
  }

  const exportEnrolled = () => {
    if (!enrolled || enrolled.length === 0) {
      toast.error("No enrolled members to export");
      return;
    }

    const csvRows = [];
    const headers = Object.keys(enrolled[0]).filter(
      (key) => key !== "created_at" && key !== "updated_at",
    );
    csvRows.push(headers.join(","));

    for (const row of enrolled) {
      const values = headers.map((header) => {
        const val =
          row[header] === null || row[header] === undefined ? "" : row[header];
        const escaped = ("" + val).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    }

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", downloadUrl);
    link.setAttribute("download", `admin_enrolled_report_${date}_${year}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportPending = () => {
    if (!pending || pending.length === 0) {
      toast.error("No pending payments to export");
      return;
    }

    const csvRows = [];
    const headers = Object.keys(pending[0]).filter(
      (key) => key !== "created_at" && key !== "updated_at",
    );
    csvRows.push(headers.join(","));

    for (const row of pending) {
      const values = headers.map((header) => {
        const val =
          row[header] === null || row[header] === undefined ? "" : row[header];
        const escaped = ("" + val).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    }

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", downloadUrl);
    link.setAttribute(
      "download",
      `admin_pending_payments_report_${date}_${year}.csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // React.useEffect(() => {
  //     getReportData();
  // }, [date]);

  return (
    <Container maxW="9xl" my="6">
      <VStack width="100%" spacing={4}>
        <Card borderRadius="md" p="4" width={"100%"}>
          <HStack justifyContent="space-between" w="100%">
            <Text fontWeight="600" className="customfont" fontSize="2xl">
              Report
            </Text>
          </HStack>
        </Card>

        <Card borderRadius="md" p="4" width={"100%"}>
          <HStack justifyContent="start" w="100%">
            <Text fontWeight="600" className="customfont" fontSize="md">
              Select{" "}
            </Text>
            <Box maxW="50%">
              {/* list of dropdown for months with value being month number and display is month name */}
              <Input
                as="select"
                value={year}
                onChange={(e) => {
                  setYear(e.target.value);
                  // getReportData();
                }}
              >
                <option value="">Select Year</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
                <option value="2031">2031</option>
                <option value="2032">2032</option>
                <option value="2033">2033</option>
                <option value="2034">2034</option>
                <option value="2035">2035</option>
              </Input>
            </Box>
            <Box maxW="50%">
              {/* list of dropdown for months with value being month number and display is month name */}
              <Input
                as="select"
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                  // getReportData();
                }}
              >
                <option value="">Select Month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </Input>
            </Box>
            <Box maxW="50%">
              <Input
                as="select"
                value={selectedLocation}
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                  // getReportData();
                }}
              >
                <option value="">Select Location</option>
                <option value="-1">All Locations</option>
                {location.map((l, idx) => {
                  return (
                    <option key={idx} value={l.id}>
                      {l.name}
                    </option>
                  );
                })}
              </Input>
            </Box>
            <Box maxW="150px">
              <Input
                as="select"
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
              >
                <option value="">Select Status</option>
                <option value={MEMBERSHIP_STATUSES.ACTIVE}>
                  {MEMBERSHIP_STATUSES.ACTIVE}
                </option>
                <option value={MEMBERSHIP_STATUSES.CANCELLED}>
                  {MEMBERSHIP_STATUSES.CANCELLED}
                </option>
                <option value={MEMBERSHIP_STATUSES.REDEEMED}>
                  {MEMBERSHIP_STATUSES.REDEEMED}
                </option>
              </Input>
            </Box>

            <Button colorScheme="primary" onClick={getReportData}>
              Get Report
            </Button>
            <Button colorScheme="blue" onClick={exportEnrolled}>
              Export Enrolled
            </Button>
            <Button colorScheme="blue" onClick={exportPending}>
              Export Pending Payments
            </Button>

            {loading && <CircularProgress isIndeterminate color="green.300" />}
          </HStack>
        </Card>

        {!loading && enrolled !== null && collection.length > 0 && (
          <HStack w="100%">
            <Card p="3">
              <Text>
                Total Collection : Rs. {collection[0].collection || 0}
              </Text>
            </Card>
            <Card p="3">
              <Text>
                Collected : Rs.{" "}
                {(collection[0].collection || 0) -
                  (pendingCollection[0].collection || 0)}
              </Text>
            </Card>
            <Card p="3">
              <Text>
                Pending Collection : Rs. {pendingCollection[0].collection || 0}
              </Text>
            </Card>
            <Card p="3">
              <Text>Total Enrolled : {enrolled.length || 0} Users</Text>
            </Card>
            <Card
              p="3"
              bg={isSetToShowAll ? "green.200" : "white"}
              onClick={() => {
                setIsSetToShowAll(true);
                setFilteredData(pending);
              }}
              cursor="pointer"
            >
              <HStack>
                <Text>Show All</Text>
                <Checkbox colorScheme="green" isChecked={isSetToShowAll} />
              </HStack>
            </Card>
            <Card
              p="3"
              bg={isSetToShowAll ? "white" : "green.200"}
              onClick={() => {
                setIsSetToShowAll(false);
                console.log(pending.filter((c) => c.paid_by_user == false));
                let unPaid = pending.filter((c) => c.paid_by_user == false);
                setFilteredData(unPaid);
              }}
              cursor="pointer"
            >
              <HStack>
                <Text>Show Pending Only</Text>
                <Checkbox colorScheme="green" isChecked={!isSetToShowAll} />
              </HStack>
            </Card>
          </HStack>
        )}

        {!loading && pending !== null && pending.length > 0 && (
          <Card width={"100%"}>
            <Text p="4" fontWeight="600" className="customfont" fontSize="lg">
              Payments
            </Text>

            <table>
              <thead>
                <tr>
                  <th py="4" fontSize="sm">
                    Id
                  </th>
                  <th py="4" fontSize="sm">
                    Plan
                  </th>
                  <th py="4" fontSize="sm">
                    Name
                  </th>
                  <th py="4" fontSize="sm">
                    Number
                  </th>
                  <th py="4" fontSize="sm">
                    Email
                  </th>
                  <th py="4" fontSize="sm">
                    Amount
                  </th>
                  <th py="4" fontSize="sm">
                    Payment Date
                  </th>
                  <th py="4" fontSize="sm">
                    User Paid
                  </th>
                  <th py="4" fontSize="sm">
                    Store Accepted
                  </th>
                  <th py="4" fontSize="sm">
                    Store
                  </th>
                  <th py="4" fontSize="sm">
                    Enrollment Date
                  </th>
                  <th py="4" fontSize="sm">
                    New User ?
                  </th>
                  <th py="4" fontSize="sm">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {/* {pending.map((u, idx) => { */}
                {filteredData.map((u, idx) => {
                  return (
                    <tr key={idx}>
                      <td py="4" fontSize="sm">
                        {u.id_number}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.scheme_name}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.name}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.phone}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.e_mail}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.monthly_price}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.payment_date}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.paid_by_user ? "YES" : "NO"}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.accepted_by_store ? "YES" : "NO"}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.locationname}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {moment(u.enrollment_date).format("DD-MM-YYYY")}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {moment(u.enrollment_date).format("YYYY-MM") ===
                        moment().format("YYYY-MM")
                          ? "YES"
                          : "NO"}
                      </td>
                      <td py="4" fontSize="sm">
                        <Button colorScheme="purple">
                          <Link to="/users/memberships/installments" state={u}>
                            View
                          </Link>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        )}

        {!loading && enrolled !== null && enrolled.length > 0 && (
          <Card width={"100%"}>
            <Text p="4" fontWeight="600" className="customfont" fontSize="lg">
              Enrolled Users
            </Text>

            <table>
              <thead>
                <tr>
                  <th py="4" fontSize="sm">
                    Id
                  </th>
                  <th py="4" fontSize="sm">
                    Plan
                  </th>
                  <th py="4" fontSize="sm">
                    Name
                  </th>
                  <th py="4" fontSize="sm">
                    Number
                  </th>
                  <th py="4" fontSize="sm">
                    Email
                  </th>
                  <th py="4" fontSize="sm">
                    Amount
                  </th>
                  <th py="4" fontSize="sm">
                    Payment Date
                  </th>
                  <th py="4" fontSize="sm">
                    Store
                  </th>
                  <th py="4" fontSize="sm">
                    Enrollment Date
                  </th>
                  <th py="4" fontSize="sm">
                    New User ?
                  </th>
                </tr>
              </thead>

              <tbody>
                {enrolled.map((u, idx) => {
                  return (
                    <tr key={idx}>
                      <td py="4" fontSize="sm">
                        {u.id_number}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.scheme_name}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.name}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.phone}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.e_mail}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.monthly_price}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.payment_date}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {u.locationname}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {moment(u.enrollment_date).format("DD-MM-YYYY")}
                      </td>
                      {/* <td py='4' fontSize='sm'> {moment(u.enrollment_date).format('YYYY-MM') === moment().format('YYYY-MM') ? 'YES' : 'NO'}</td> */}
                      <td py="4" fontSize="sm">
                        {" "}
                        {moment(u.enrollment_date).format("YYYY-MM") ===
                        `${year}-${date.padStart(2, "0")}`
                          ? "YES"
                          : "NO"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        )}
      </VStack>
    </Container>
  );
}
